import ApiService from "@/services/api.service";
import getters from "@/store/global";
import store from "@/store";

const state = {
    packages: [],
    replenishmentLink: "",
    errors: {},
};

getters["fetchPackages"] = function (state) {
    return state.packages;
};
getters["fetchReplenishmentLink"] = function (state) {
    return state.replenishmentLink;
};

const actions = {
    getPackages(context) {
        return ApiService.get("packages/")
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("SET_PACKAGES", response.data);
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
    withdraw(context, payload) {
        return ApiService.put("withdrawal/", payload)
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("UPDATE_WITHDRAWAL_DATE");
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
    replenish(context, payload) {
        let url = "payment_create/";

        return ApiService.post(url, {
            user: store.getters["user/fetchUser"].id,
            package: payload[0],
        })
            .then((response) => {
                const { invoice_id, url } = response.data;
                context.commit("SET_REPLENISHMENT_LINK", url);
                context.commit("SET_ERROR", {});

                return {
                    user: payload,
                    invoice_id: invoice_id,
                    package: payload[1],
                    url: url,
                };
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
    exchange(context, payload) {
        return ApiService.get(
            "account_balance/exchange/" + payload.amount + "/"
        )
            .then((response) => {
                context.commit("SET_ERROR", {});
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
};

const mutations = {
    SET_PACKAGES(state, packages) {
        state.packages = packages;
        state.errors = {};
    },
    SET_REPLENISHMENT_LINK(state, replenishmentLink) {
        state.replenishmentLink = replenishmentLink;
    },
    UPDATE_WITHDRAWAL_DATE(state) {
        store.dispatch("user/setWithdrawalDate", Math.ceil(+new Date() / 1000));
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
